import { createSlice } from "@reduxjs/toolkit";
import { fetchWalletDetails } from "./WalletServices";
import { WalletData } from "../../types/paymentTypes";

interface WalletState {
  data: WalletData | null;
  loading: boolean;
}

const initialState: WalletState = {
  data: null,
  loading: false,
};

const walletSlice = createSlice({
  name: "wallet",
  initialState,
  reducers: {
    resetWallet: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchWalletDetails.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchWalletDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchWalletDetails.rejected, (state) => {
        state.loading = false;
      });
  },
});

export const { resetWallet } = walletSlice.actions;
export default walletSlice.reducer;
